module.exports = __webpack_public_path__ + "img/dui.9ca5df29.png";